var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaggageChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3C8 1.89543 8.89543 1 10 1H14C15.1046 1 16 1.89543 16 3V4H17C18.1046 4 19 4.89543 19 6V20C19 21.1046 18.1046 22 17 22C17 22.5523 16.5523 23 16 23C15.4477 23 15 22.5523 15 22H9C9 22.5523 8.55228 23 8 23C7.44772 23 7 22.5523 7 22C5.89543 22 5 21.1046 5 20V6C5 4.89543 5.89543 4 7 4H8V3ZM14 3V4H10V3H14ZM8 9H16V8H8V9Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaggageChecked);
export default __webpack_public_path__ + "static/media/baggage_checked.6a495f92ab69cb405c1cfb37e425efbc.svg";
export { ForwardRef as ReactComponent };